import React, { useState } from "react";
import styles from "./styles.module.css";
import { AnimalKrcMap } from "../animalkrcmap/index";
import { 
    AnimalTable, 
    TotalAnimalTable, 
  } from "../../../components/tables/index";
  import KRCandMRCChart from "../../tables/animaltables/krcandmrcnanimal/table1";
  import KRCandMRCChartSecond from "../../tables/animaltables/krcandmrcnanimal/table2";
  import BirdChart from "../../tables/animaltables/krcandmrcnanimal/birds";
  import KRCChart from "../../tables/animaltables/krcandmrcnanimal/krc";
  import Cowhart from "../../tables/animaltables/krcandmrcnanimal/kine";
  import HorseChart from "../../tables/animaltables/krcandmrcnanimal/horse";
  import Sheephart from "../../tables/animaltables/krcandmrcnanimal/sheep";
  import Pigshart from "../../tables/animaltables/krcandmrcnanimal/pigs";
import styled from "styled-components";
import { Button } from "antd";

const Container = styled.div`
  position: relative;
  height: 100vh;

`;

const Content = styled.div`

`;

const ButtonContainer = styled.div`
  position: fixed;
  top: 10px;
  left: 50%;
  transform: translateX(-50%);
  display: flex;
  gap: 10px;
  z-index: 999;
`;

export const AnimalKrc = () => {
  const [collapsed, setCollapsed] = useState(false);

  
  const [activeTab, setActiveTab] = useState<"map" | "statistics">("map");

 
  const toggleSidebar = () => {
    setCollapsed(!collapsed);
  };


  const handleTabChange = (tab: "map" | "statistics") => {
    setActiveTab(tab);
  };

  return (
    <Container>
      {/* <Sidebar collapsed={collapsed} /> */}
      <Content>
        <ButtonContainer>
          <Button
            type={activeTab === "map" ? "primary" : "default"}
            onClick={() => handleTabChange("map")}
          >
            Карта
          </Button>
          <Button
            type={activeTab === "statistics" ? "primary" : "default"}
            onClick={() => handleTabChange("statistics")}
          >
            Статистика и аналитика
          </Button>
        </ButtonContainer>

        {activeTab === "map" ? (
          <div className={styles.mapBackground}>
            <AnimalKrcMap latitude={41.5089324} longitude={74.724091} />
            <TotalAnimalTable />
            <AnimalTable/>
          </div>
        ) : (
            <div className={styles.tables_krc_and_mrc}>
          <KRCandMRCChart />
          <KRCandMRCChartSecond/>
          <BirdChart/>
          <KRCChart/>
          <Cowhart/>
          <HorseChart/>
          <Sheephart/>
          <Pigshart/>
        
         </div>
        )}
      </Content>
    </Container>
  );
};
